// Sets the subject on a mailto: support URL, replacing any existing subject.
// Non-mailto URLs are returned unchanged.
export function withMailtoSubject(url: string, subject: string): string {
	if (!/^mailto:/i.test(url)) {
		return url;
	}

	const [address, query = ""] = url.split(/\?(.*)/s);
	const params = query
		.split("&")
		.filter((param) => param && !/^subject=/i.test(param));
	params.push(`subject=${encodeURIComponent(subject)}`);

	return `${address}?${params.join("&")}`;
}
